import { createFileRoute } from '@tanstack/react-router'

import { CenteredLayout } from '~/layout/centered-layout'

import { mainRouteSchema } from './-schemas/main-route-schema'

export const Route = createFileRoute('/auth')({
  component: CenteredLayout,
  validateSearch: search => mainRouteSchema.parse(search),
})
